import React, { Component } from "react";
import EditableText from "../../../../common/editableText/index";

import "../../customize.scss";

export class PromotionEditor extends Component {
    constructor(props) {
        super(props);
    }

    handleUpdate = (index, key, value, tagIndex) => {
        this.props.events.handleUpdate(this.props.data.promotion, index, key, value, tagIndex);
    };

    render() {
        let { languageCode, promotion } = this.props.data;
        
        if(!promotion) return null;
        let promotionIndex = this.props.data?.promotion?.id || "0";

        return (
            <EditableText languageCode={ languageCode } placeHolderObjects={promotion?.placeHolderObjects || []} allEditable={true} enable={promotion.included || false} prefixKey={promotionIndex} text={promotion.description} handleUpdate={this.handleUpdate}/>
        );
    }
}

export default PromotionEditor;
